function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 30 22",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.82 7.483l-5.587 5.613v.738l-5.613.29V8.036l11.2-.553z",
  fill: "#C2E5E1",
  stroke: "#4D5861",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.868 13.702l-.105.027v-.027h.105z",
  fill: "#fff",
  stroke: "#4D5861",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.62 8.056v6.088a3.892 3.892 0 010-.554V7.536c-.026.158 0 .316 0 .52z",
  fill: "#fff",
  stroke: "#828A90",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.994 7.43v6.088a3.548 3.548 0 01-.132.922c-.037.18-.09.357-.158.527a3.895 3.895 0 01-.857 1.476c-.131.158-.263.29-.448.474l-.421.37a7.171 7.171 0 01-1.186.843l-.08.052a6.481 6.481 0 01-1.053.5c-.395.185-.79.344-1.239.502-.448.158-.79.237-1.186.342h-.184c-.434.112-.874.2-1.318.264-.47.078-.946.131-1.423.158-.49.052-.983.079-1.476.079a9.157 9.157 0 01-1.185-.053c-.29 0-.554-.052-.844-.079h-.184l-.844-.105-.448-.08a13.95 13.95 0 01-1.423-.342l-.408-.112-.29-.079v-6.08l.29.078.369.105c.467.143.942.257 1.423.343l.448.08h.105l.712.105h.184c.29 0 .554.079.844.079.393.043.79.061 1.185.052.485 0 .969-.026 1.45-.079.477-.023.952-.076 1.423-.158.461-.062.919-.15 1.37-.263h.158a8.14 8.14 0 001.213-.37 8.293 8.293 0 001.212-.474c.368-.13.721-.297 1.054-.5l.08-.053.658-.422c.21-.158.369-.29.527-.421l.395-.37c.171-.146.322-.314.448-.5a3.69 3.69 0 00.896-1.45c.072-.167.116-.345.132-.526.111-.297.182-.607.21-.923z",
  fill: "#C2E5E1",
  stroke: "#828A90",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.868 13.702l-.105.027v-.027h.105z",
  fill: "#fff",
  stroke: "#4D5861",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.993 7.43a3.543 3.543 0 01-.131.922c-.016.182-.06.36-.132.528a3.69 3.69 0 01-.883 1.449 2.553 2.553 0 01-.448.5l-.395.37c-.159.131-.317.263-.527.421l-.66.422-.078.053a5.58 5.58 0 01-1.054.5c-.391.19-.797.349-1.213.475-.394.154-.799.277-1.212.369h-.158c-.451.113-.909.2-1.37.263-.471.082-.946.134-1.423.158-.482.053-.966.08-1.45.08a8.914 8.914 0 01-1.186-.053c-.29 0-.553-.053-.843-.08h-.184l-.712-.105h-.132l-.448-.079c-.48-.086-.956-.2-1.423-.342l-.369-.106-.29-.079 5.587-5.613-11.2.553v-.5c.005-.238.022-.476.053-.712l.132-.5.052-.159.185-.474c.2-.398.447-.77.738-1.107.119-.168.26-.319.421-.448.267-.273.558-.52.87-.738a5.89 5.89 0 01.79-.527 7.25 7.25 0 011.107-.553 9.638 9.638 0 011.213-.475c.237-.079.5-.158.79-.237l.606-.132c.337-.104.68-.183 1.028-.237A17.683 17.683 0 0117.543 1h.922c.29 0 .58 0 .87.053l.922.079c.56.077 1.115.19 1.66.336.555.109 1.101.259 1.634.448.264.105.501.21.738.29.23.074.45.17.66.29.264.11.52.242.763.395.264.158.527.316.765.474a8.2 8.2 0 01.658.527l.396.316.184.238c.172.175.322.37.448.58.106.152.203.31.29.474l.158.237c.161.325.276.671.343 1.028.04.22.053.443.04.665z",
  fill: "#fff",
  stroke: "#828A90",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.206 9.334l-5.567 5.62a12.443 12.443 0 01-2.325-1.034c-1.977-1.133-3.03-2.563-3.294-4.013l11.186-.573z",
  fill: "#fff",
  stroke: "#828A90",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.206 9.334l-.02 6.094-5.567 5.613.02-6.087 5.567-5.62z",
  fill: "#fff",
  stroke: "#828A90",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.258 14.572L7.562 18.3M7.562 17.049l3.702-3.722M7.568 15.804l3.696-3.729",
  stroke: "#828A90",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.64 14.954v6.088a12.366 12.366 0 01-2.32-1.028c-1.976-1.14-3.037-2.57-3.294-4.012V9.907c.257 1.45 1.318 2.88 3.294 4.013.736.423 1.513.77 2.32 1.034z",
  fill: "#C2E5E1",
  stroke: "#828A90",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

export default SvgComponent;